(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in2r-complete-homepage"] && !Shopify.designMode) return;
  try {
    
  const getIN2RCaptionCues = () => [[2.44,3.96,"I just feel that, you know,"],[3.96,6.52,"speaking your mind about how you truly feel"],[6.52,8.88,"and what you're going through is very important,"],[8.88,11.4,"because for me, I was going through it in silence"],[11.4,13.38,"for three to four years."],[19.0,20.04,"Growing up, I was..."],[20.04,22.64,"I was always a very active kid."],[22.64,24.5,"I always loved getting out and about."],[26.04,29.64,"I ended up breaking my leg in Grade 10"],[29.64,31.72,"and couldn't end up playing football in my"],[31.72,32.86,"Grade 11 year."],[32.96,36.1,"So that kind of took a toll on my mental state."],[36.2,37.24,"From there,"],[37.24,38.92,"things just kept going downwards,"],[38.92,42.0,"and I slowly began just, you know,"],[42.0,44.2,"having no motivation from Grade 10 to 12."],[44.2,46.52,"I hadn't really spoken about it with my parents,"],[46.52,49.72,"and I hadn't really given it a hard look in the mirror"],[49.72,50.24,"and, you know,"],[50.24,52.62,"questioned what was going on."],[53.08,56.5,"June 14th of 2019 was"],[56.56,58.72,"the day I tried taking my life."],[58.72,62.12,"That day, I just remember it was a couple weeks before grad,"],[62.12,64.62,"and my anxiety was terrible."],[66.72,69.44,"I didn't know what I wanted to do after high school."],[69.44,72.08,"I felt that, you know,"],[72.08,76.8,"I didn't have anyone. I felt lost."],[76.8,79.56,"I started thinking to myself,"],[79.56,80.72,"what are my parents gonna think?"],[80.72,82.46,"How are they gonna feel?"],[82.88,85.06,"What about my friends? What about my family?"],[87.28,89.36,"And so I quickly realized,"],[89.36,91.58,"you know, I have to do something about this."],[91.8,93.32,"I've done multiple things."],[93.32,95.6,"I actually went to my family doctor."],[95.6,98.08,"He told me, like, you have no idea"],[98.08,100.16,"how many kids I take in nowadays"],[100.16,102.5,"because of anxiety and depression."],[103.36,106.16,"For me, the easiest way to deal with my mental health"],[106.16,108.04,"is to get out and about and,"],[108.04,110.18,"you know, free my mind by riding."],[111.24,113.68,"I wanted to become a lawyer originally."],[113.68,116.96,"Quickly found out that it wasn't what I wanted to do."],[118.16,119.84,"I wanted to possibly get a job or,"],[119.84,121.36,"you know, start a business or something."],[121.36,122.48,"And so my dad said, you know,"],[122.48,124.3,"figure out a plan. And I said,"],[124.8,128.02,"what if we made a brand out of my story?"],[128.68,129.76,"I thought, you know,"],[129.76,131.66,"why not make a lifestyle brand"],[131.92,134.24,"and something where it's aimed at extreme sports,"],[134.24,135.7,"where it also, you know,"],[135.76,140.16,"influences a positive"],[140.16,142.0,"and active lifestyle"],[142.0,144.78,"in order to cope with those illnesses?"],[145.44,148.04,"Life is a ride. It has plenty of ups and downs."],[148.04,150.08,"I've gone through plenty of them."],[150.08,152.76,"Every time, you take the time to take care of yourself"],[152.76,156.2,"and just realize that today is one day,"],[156.2,158.18,"and that tomorrow is a whole new day."],[159.44,161.6,"We had a couple customers that told me, hey,"],[161.6,164.6,"you know, your brand actually really resonated with me,"],[164.6,165.9,"to the point where it actually"],[166.16,169.34,"stopped me from doing something terrible."],[170.32,171.6,"Right now, I'm currently working on"],[171.6,174.12,"partnering with the Canadian Mental Health Association"],[174.12,176.32,"and becoming a partner to do donations to them"],[176.32,176.84,"as well,"],[176.84,179.66,"and just another way of giving back to our community."],[183.76,185.92,"I just want people to know that they're not alone."],[185.92,187.44,"They have someone to talk to"],[187.44,188.6,"if they're ever feeling down,"],[188.6,190.18,"and that I've been there,"],[190.2,192.36,"and I completely understand how they're feeling."],[192.36,194.84,"And there is a way to, you know,"],[194.84,196.8,"approach mental health"],[196.8,200.24,"and anxiety and depression and all those sorts of things,"],[200.24,201.66,"and it is to speak up."],[203.96,205.4,"Aidan is incredibly brave,"],[205.4,207.66,"not just for sharing his story with us,"],[207.8,209.32,"but also for reaching out"],[209.32,211.42,"when he realized he needed help."],[211.64,212.36,"If you feel like"],[212.36,213.92,"you're struggling with your mental health,"],[213.92,217.1,"there are a number of resources that you can utilize,"],[217.16,220.36,"including the Canadian Suicide Prevention Hotline"],[220.36,221.78,"and the Kids Help Phone."],[221.88,224.3,"More information can be found over here on the left."],[224.68,226.12,"Take care of yourself,"],[226.12,228.1,"and don't be afraid to ask for help."]];

  const initIN2RStoryCaptions = (root) => {
    const scope = root || document;
    let shells = [];

    if (scope.matches && scope.matches('[data-in2r-story-caption-shell]')) {
      shells = [scope];
    } else if (scope.querySelectorAll) {
      shells = Array.from(scope.querySelectorAll('[data-in2r-story-caption-shell]'));
    }

    shells.forEach((shell) => {
      if (shell.dataset.in2rCaptionsReady === 'true') return;

      const button = shell.querySelector('[data-in2r-story-caption-toggle]');
      const video = shell.querySelector('video');

      if (!button || !video || !window.VTTCue || typeof video.addTextTrack !== 'function') {
        if (button) button.hidden = true;
        shell.dataset.in2rCaptionsReady = 'true';
        return;
      }

      let track = null;

      const ensureTrack = () => {
        if (track) return track;

        track = video.addTextTrack('captions', 'English', 'en');
        track.mode = 'hidden';

        getIN2RCaptionCues().forEach((cue) => {
          try {
            const item = new VTTCue(cue[0], cue[1], cue[2]);
            item.line = 'auto';
            item.align = 'center';
            track.addCue(item);
          } catch (error) {
            console.warn('IN2R caption cue could not be added:', error);
          }
        });

        return track;
      };

      const setCaptionState = (enabled) => {
        const activeTrack = ensureTrack();
        activeTrack.mode = enabled ? 'showing' : 'hidden';
        button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
        button.textContent = enabled ? 'CC Captions: On' : 'CC Captions: Off';
      };

      button.addEventListener('click', () => {
        const activeTrack = ensureTrack();
        setCaptionState(activeTrack.mode !== 'showing');
      });

      button.setAttribute('aria-pressed', 'false');
      button.textContent = 'CC Captions: Off';
      shell.dataset.in2rCaptionsReady = 'true';
    });
  };

  initIN2RStoryCaptions(document);

  document.addEventListener('shopify:section:load', (event) => {
    initIN2RStoryCaptions(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in2r-forms-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('in2r-forms-popup')) {
    customElements.define('in2r-forms-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.isEditor = this.dataset.designMode === 'true';
        this.storageKey = `in2r-forms-popup-dismissed-${this.dataset.sectionId}`;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-method-panel]'));
        if (this.tabs.length === 2 && this.panels.length === 2) {
          this.selectMethod(this.dataset.defaultMethod === 'sms' ? 'sms' : 'email');
          this.querySelector('[role="tablist"]').hidden = false;
        }
        this.onClick = (event) => {
          if (event.target.closest('[data-popup-close]')) {
            this.closePopup(true);
            return;
          }
          if (event.target === this.dialog) {
            const bounds = this.dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closePopup(true);
          }
          const tab = event.target.closest('[role="tab"]');
          if (this.tabs.includes(tab)) this.selectMethod(tab.dataset.method);
        };
        this.onKeydown = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : (index + 1) % 2;
          this.selectMethod(this.tabs[next].dataset.method);
          this.tabs[next].focus();
        };
        this.onCancel = (event) => {
          event.preventDefault();
          this.closePopup(true);
        };
        this.onClose = () => this.restoreScroll();
        this.onSectionSelect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.openPopup();
        };
        this.onSectionDeselect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.closePopup(false);
        };
        this.onBlockSelect = (event) => {
          const panel = this.panels.find((item) => item.dataset.blockId === event.detail?.blockId);
          if (panel) {
            this.selectMethod(panel.dataset.methodPanel);
            this.openPopup();
          }
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.dialog.addEventListener('cancel', this.onCancel);
        this.dialog.addEventListener('close', this.onClose);
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        let dismissed = false;
        try { dismissed = sessionStorage.getItem(this.storageKey) === 'true'; } catch {}
        if (this.isEditor || !dismissed) {
          const delay = this.isEditor ? 0 : Math.max(0, Number(this.dataset.delay) || 0) * 1000;
          this.timer = setTimeout(() => this.openPopup(), delay);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.closePopup(false);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.dialog?.removeEventListener('cancel', this.onCancel);
        this.dialog?.removeEventListener('close', this.onClose);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.initialized = false;
      }

      openPopup() {
        if (!this.dialog || this.dialog.open || !this.isConnected) return;
        clearTimeout(this.timer);
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }

      closePopup(remember) {
        clearTimeout(this.timer);
        if (remember && !this.isEditor) {
          try { sessionStorage.setItem(this.storageKey, 'true'); } catch {}
        }
        if (this.dialog?.open) this.dialog.close();
        this.restoreScroll();
      }

      restoreScroll() {
        if (this.previousOverflow === undefined) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }

      selectMethod(method) {
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.method === method;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.methodPanel !== method; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
